import React from 'react'
import {Navigate, Route, Routes} from 'react-router-dom'
import {DossierWrapper} from "../pages/Dossier/DossierWrapper";
import {ParametrageWrapper} from "../pages/Parametrage/ParametrageWrapper";
import Sidebar from "../pages/components/Sidebar";
// import DashboardPageOld from "../pages/Dashboard/DashboardPageOld";
import DashboardPage from "../pages/Dashboard/DashboardPage";
import IndicateurDashboardPage from "../pages/Dashboard/IndicateurDashboardPage";
import DocumentationPage from "../pages/Documentation/DocumentationPage";

const PrivateRoutes = () => {
  return (
    <Sidebar>
      <Routes>
        <Route path='/accueil' element={<DashboardPage/>}/>
        <Route path='/dashboard' element={<IndicateurDashboardPage/>}/>
        <Route path='/dossiers/*' element={<DossierWrapper/>}/>
        <Route path='/parametrage/*' element={<ParametrageWrapper/>}/>
        <Route path='/documentation' element={<DocumentationPage/>}/>

        <Route path='*' element={<Navigate to='/404' replace/>}/>
      </Routes>
    </Sidebar>
  )
}

export {PrivateRoutes}
